/**
 * 解析简易登录Url参数
 * urlParams=mode-easy_lastName-lian_firstName-jie_account-784123123
 * @param {String} str
 * @returns {Object} { mode: easy, lastName, firstName, account }
 */
export function parseLoginUrlParams(str) {
  return decodeURI(str)
    .split("_")
    .reduce(function(a, b) {
      var before = b.match(/(\S*)-/)[1];
      var after = b.match(/-(\S*)/)[1];
      if (a[before]) {
        return a;
      }
      a[before] = after;
      return a;
    }, {});
}

export function parseUrlParams(str) {
  return decodeURIComponent(str)
    .split("&")
    .reduce(function(total, currentValue) {
      total[currentValue.split("=")[0]] = currentValue.split("=")[1];
      return total;
    }, {});
}

// 对params参数处理  返回一个由‘&’拼接的字符串
export function toQueryString(obj) {
  return obj
    ? Object.keys(obj)
        .sort()
        .map(key => {
          if (key === "" || key === null || key === undefined) {
            return false;
          }

          const val = obj[key];
          if (Array.isArray(val)) {
            return val
              .sort()
              .map(val2 => {
                return `${key}=${val2}`;
              })
              .join("&");
          }

          if (val === "" || val === undefined) {
            return false;
          }

          return `${key}=${encodeURI(val)}`;
        })
        .join("&")
    : "";
}

// 是否为App
export function isApp() {
  if (
    window.CSNativeObject &&
    window.CSNativeObject.nativeSetTitle &&
    typeof window.CSNativeObject.nativeSetTitle === "function"
  ) {
    return true;
  } else {
    return false;
  }
}

// 记录头部隐藏属性，由于 t=fromClient 只有在初始化的时候存在，切换的时候不存在。
let headerDisplayValue = null;
// 显示头部标题, url包含t=fromClient, 或者app中打开
export function displayHeader(title, statusBarColor) {
  if (
    headerDisplayValue === false ||
    window.location.href.includes("t=fromClient") ||
    isApp()
  ) {
    if (isApp()) {
      window.CSNativeObject.nativeSetTitle &&
        window.CSNativeObject.nativeSetTitle(title);
      statusBarColor &&
        window.CSNativeObject.nativeDisplayTitle &&
        window.CSNativeObject.nativeDisplayTitle(
          JSON.stringify({ displayTitle: true, statusBarColor })
        );
    }
    if (headerDisplayValue === null) headerDisplayValue = false;
    return headerDisplayValue;
  }
  if (headerDisplayValue === null) headerDisplayValue = true;
  return headerDisplayValue;
}

// 统一登录重定向地址
let allLoginRedirect = "";
// 设置统一登录重定向地址
export function setAllLoginRedirect(redirect) {
  allLoginRedirect = redirect;
}
// 登录
export function allLogin() {
  if (isApp()) {
    try {
      // 需要先判断 android 需要登出再登录， ios 直接登录
      if (window.CSNativeObject.getOSType() === "android") {
        //collectPage(['android登录', 'android登录', 'android app 登录']);
        // 先退出，再登录，解决安卓token失效后一直死循环查不出数据问题
        window.CSNativeObject.nativeLoginOut("callback");
        window.callback = function() {
          window.CSNativeObject.nativeLogin("callback");
          window.callback = function() {
            window.location.reload();
          };
        };
      } else {
        //collectPage(['ios登录', 'ios登录', 'ios app 登录']);
        window.CSNativeObject.nativeLogin("callback");
        window.callback = function() {
          window.location.reload();
        };
      }
    } catch (e) {
      // catch exception;
    }
  } else {
    //collectPage(['统一登录', '统一登录', '统一登录']);
    const url = encodeURIComponent(allLoginRedirect);
    window.location.href = `${
      process.env.VUE_APP_LOGIN
    }touch/com.csair.mbp.index/index.html#com.csair.mbp.login/login?t=forward&redirect=${url}&channel=ETM&loginFuncMannel=%E9%80%80%E7%A5%A8%E5%8D%95%E6%9F%A5%E8%AF%A2&sysId=ETM&loginMode=0&coopAccount=`;
  }
}

/**
 * @description 保存本地数据
 * @param {string} key
 * @param data
 */
export function saveLocalData(key, data) {
  if (isApp()) {
    window.CSNativeObject.saveDataLocalStorage(JSON.stringify({ [key]: data }));
  } else {
    localStorage.setItem(key, JSON.stringify(data));
  }
}

/**
 * @description 获取本地数据
 * @param {string} key
 * @returns
 */
export function getLocalData(key) {
  let data = null;
  if (isApp()) {
    data = window.CSNativeObject.getDataLocalStorage(
      JSON.stringify({ keyName: key })
    );
  } else {
    data = localStorage.getItem(key);
  }
  try {
    if (typeof data === "string") {
      data = JSON.parse(data);
    }
  } catch (error) {
    data = null;
  }
  return data;
}

/**
 * @description 设置APP头部title
 * @param {*} title
 */
export function setAppHeaderTitle(title) {
  try {
    window.CSNativeObject.nativeSetTitle(title || "");
  } catch (e) {
    // catch exception;
  }
}
